import { deleteRest, get, post } from 'utils/rxfetch'

export default {
  getAtoCampaignBanner(companyId = '') {
    return get(`/members-api/ato-campaign/banner?companyFilter=${companyId}`)
  },
  postAtoCampaignContactMe(companyId = '') {
    return post(`/members-api/ato-campaign/banner?companyFilter=${companyId}`, {})
  },
  deleteAtoCampaignBanner(companyId = '') {
    return deleteRest(`/members-api/ato-campaign/banner?companyFilter=${companyId}`)
  },
}
